
export const useUser = () => {
  const user = useSupabaseUser()
  const client = useSupabaseClient()
  const router = useRouter()

  const login = async (email: string, password: string) => {
    const { error } = await client.auth.signInWithPassword({
      email,
      password
    })
    return { error }
  }

  /**
   * Signs the visitor up.
   *
   * `data.session` is null when the Supabase project requires e-mail
   * confirmation — callers that need to continue straight into a paid flow must
   * check for it instead of assuming they are logged in.
   */
  /** `metadata` lands in user_metadata, e.g. the marketing opt-in (useMarketingConsent). */
  const register = async (email: string, password: string, redirectTo?: string, metadata?: Record<string, unknown>) => {
    const { data, error } = await client.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: redirectTo || `${window.location.origin}/auth/callback`,
        ...(metadata ? { data: metadata } : {})
      }
    })
    return { data, error }
  }

  const logout = async () => {
    const { error } = await client.auth.signOut()
    if (!error) {
      // Vyčistíme cache a localStorage při odhlášení
      if (process.client) {
        // Zachováme pouze nezbytné údaje
        const language = localStorage.getItem('language')
        const analyticsTracking = localStorage.getItem('analytics_tracking_enabled')
        const visitorId = localStorage.getItem('visitor_id')

        // Vyčistíme vše
        localStorage.clear()
        sessionStorage.clear()

        // Obnovíme nezbytné údaje
        if (language) localStorage.setItem('language', language)
        if (analyticsTracking) localStorage.setItem('analytics_tracking_enabled', analyticsTracking)
        if (visitorId) localStorage.setItem('visitor_id', visitorId)
      }

      router.push('/login')
    }
    return { error }
  }

  return {
    user,
    login,
    register,
    logout
  }
}
